import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';
import Button from '../../../incase-domain/components/button/Button';
import {useForgotPassword} from './queries';
import {type TypedTranslation} from '../../../i18n';

function ForgotPasswordPage(): JSX.Element {
    const {t} = useTranslation();
    const {state} = useLocation();
    const {mutate: forgotPassword, isLoading, data: response} = useForgotPassword();
    const [email, setEmail] = useState('');

    useEffect(() => {
        if (state !== undefined && state !== null) {
            setEmail(state as string);
        }
    }, [state]);

    const isDisabled = !email.length || isLoading;

    return (
        <div className="p-forgotPassword">
            <main>
                <form
                    className="p-forgotPassword__form"
                    onSubmit={(e) => {
                        e.preventDefault();

                        if (isDisabled) return;

                        forgotPassword({email});
                    }}
                >
                    <div className="p-forgotPassword__title">{t('forgotPasswordPage.title')}</div>
                    <div className={`${response?.errors?.message && 'is-invalid'}`}>
                        <div className="c-sidepanel__input">
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                value={email}
                                type="email"
                                placeholder={t('forgotPasswordPage.enterYourEmail')}
                            />
                        </div>
                        {response?.errors && (
                            <div className="c-form-help is-invalid">{t(response?.errors?.message[0] as TypedTranslation)}</div>
                        )}
                    </div>

                    <Button className="u-mt-1" disabled={isDisabled} variant="solid" size="sm" color="secondary" fullWidth type="submit">
                        {t('forgotPasswordPage.send')}
                    </Button>

                    <a className="p-forgotPassword__backToLogin" href="/login">
                        {t('forgotPasswordPage.backToLogin')}
                    </a>
                </form>
            </main>
        </div>
    );
}

export default ForgotPasswordPage;
